<template>
  <div class="tableToolbar" :id="id">

    <slot name="main"/>
    <div class="toolbarButtons">

      <h3 v-if="title">{{ title }}</h3>
      <div style="display: inline-flex" v-if="buttons?.includes('filter')">
        <i :class="{isFilterShown}" class="toolbarButton ri-filter-2-line" ref="filterButtonRef"
           @click="$emit('toggleFilter')"/>
        <slot name="toolbarFilter" :filterButtonRef="$refs.filterButtonRef"/>
      </div>

      <Popper arrow :hover="true" :content="info" v-if="buttons?.includes('info')">
        <i class="toolbarButton ri-information-line"/>
      </Popper>

      <i v-if="buttons?.includes('newsfeed')" class="toolbarButton ri-newspaper-line" @click="onNewsfeed()"/>
      <div class="closeButton" @click="$emit('close')" v-if="buttons.includes('close')">
        <i class="ri-close-line"/>
        {{ dictionary.settingsPage.buttons.close }}
      </div>
    </div>
  </div>
</template>

<script>

import Popper from "vue3-popper";

export default {
  name: "TableToolbar",
  props: ['buttons', 'info', 'title', 'onNewsfeed', 'id', 'isFilterShown'],
  components: {Popper}
}
</script>

<style scoped lang="scss">
@import "../../assets/style/vars";
@import "../../assets/style/general";

.tableToolbar {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  width: 100%;
  background: var(--bgColor);
  border-bottom: 2px dotted var(--notficationBorderColor);
  padding: 5.3px $minSpacing;
  @media(max-width: 768px) {
    justify-content: space-between;
  }
}

.toolbarButtons {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}

.toolbarButton {
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px !important;

  &:hover {
    background: var(--tableBorderColor);

  }
}

.isFilterShown {
  background: var(--lightYellowOpacity);
  color: var(--lightYellow);
}

.closeButton {
  cursor: pointer;
  background: var(--highlightColorOpacity);
  width: fit-content;
  padding: 1px 7px;
  border-radius: 8px;
  margin: 0 10px;
  font-size: 16px;
  font-weight: bold;
}

h3 {
  padding: 0 2px;
  margin: 0;
  font-size: 18px;
  font-weight: 400;
}
</style>
